import { TextInput } from 'streamlabs-beaker';
import { Component } from 'vue-property-decorator';
import StudioModalMobile from '@/components/modals/StudioModalMobile.vue';
import EditorBase from '../EditorBase';
import { EModalName } from '@/helpers/modal';
import { IProject, IScene } from '@/helpers/editor';
import { cloneDeep } from 'lodash-es';
import { EAnalyticsEvent } from '@/helpers/analytic';

@Component({
  components: {
    StudioModalMobile,
    STextInput: TextInput,
  },
})
export default class CreateSceneModal extends EditorBase {
  sceneName: string = null;

  $refs!: {
    sceneNameInput: HTMLInputElement;
  };

  get modalName(): string {
    return EModalName.createScene;
  }

  get disabled(): boolean {
    return !this.sceneName;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  async onConfirm() {
    const scene: IScene = await this.createScene(this.selectedProject.uuid, this.sceneName);

    if (scene) {
      let isFirstScene = false;
      const scenes = cloneDeep(this.selectedProject.scenes) || [];

      if (!scenes.length) isFirstScene = true;

      scenes.push(scene);

      const data: Partial<IProject> = {
        scenes,
      };

      this.selectedProject = { ...this.selectedProject, ...data };
      this.selectedScene = scene;
      this.$sla.sendEvent(EAnalyticsEvent.sceneCreated);

      if (isFirstScene) await this.setSceneAsActive(scene);
    }

    this.sceneName = null;
    this.hideModal();
  }

  modalOpened() {
    this.$refs.sceneNameInput.focus();

    window.addEventListener('keypress', this.handleKeyPress);
  }

  beforeClose() {
    window.removeEventListener("keypress", this.handleKeyPress);
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.onConfirm();
    }
  }
}
